import { render, staticRenderFns } from "./LifeEdit.vue?vue&type=template&id=2023c128&scoped=true"
import script from "./LifeEdit.vue?vue&type=script&lang=js"
export * from "./LifeEdit.vue?vue&type=script&lang=js"
import style0 from "./LifeEdit.vue?vue&type=style&index=0&id=2023c128&prod&scoped=true&lang=css"
import style1 from "./LifeEdit.vue?vue&type=style&index=1&id=2023c128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023c128",
  null
  
)

export default component.exports